import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { PaginationSearchParams } from '@/api/types';
import { trialsQueryKeys } from './trials.keys';

const allTrialsPaginationParams: PaginationSearchParams = {
  itemsPerPage: 100,
  pageIndex: 0,
};

export const trialsQueries = {
  list: () =>
    queryOptions({
      queryKey: trialsQueryKeys.getList(allTrialsPaginationParams),
      queryFn: () => api.trials.getTrialProgramsList(allTrialsPaginationParams),
      staleTime: Infinity,
    }),
};

const useTrialsListQuery = () => {
  return useQuery(trialsQueries.list());
};

export { useTrialsListQuery };
